module.exports = __webpack_public_path__ + "img/yq-bg.e28b7652.png";